import React from 'react';

import { NumberFields } from '../jbc-front/components/Form';

// This is Postal code field in thai form (Incomplete , Something required to fix via JBC-Front)
const TelFieldTh = ({ required, disabled, label, handleOnChange, prefix }) => (
  <NumberFields
    texts={[]}
    lengths={[10]}
    required={required}
    disabled={disabled}
    label={label}
    exactLength
    seperateChar=""
    prefix= {prefix || "telNumber"}
    noSuffix
    onChange={handleOnChange}
  />
);

export default TelFieldTh;
